import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ADD_NEW_VEHICLE, DOCUMENT_UPLOAD_NEW_VEHICLE, VALIDATE_NEW_VEHICLE } from "../../../../../common/constant";
import { get, post } from "../../../../../common/api";
import Api from "../../../../../common/api/multipart";

export const actionAddNewVehicle = createAsyncThunk('AddNewVehicleStore/actionAddNewVehicle', async (params) => {
  return await Api.multipart(ADD_NEW_VEHICLE, params)
})

export const actionValidateVehicle = createAsyncThunk('AddNewVehicleStore/actionValidateVehicle', async (params, thunkAPI) => {
  return await post(VALIDATE_NEW_VEHICLE, params, thunkAPI)

})

export const actionuploadDocument = createAsyncThunk('AddNewVehicleStore/actionuploadDocument', async (params, thunkAPI) => {
  return await Api.multipart(DOCUMENT_UPLOAD_NEW_VEHICLE, params)

})
export const addNewVehicleSlice = createSlice({
  name: "AddNewVehicleStore",

  initialState: {
    //get policy
    loadingAddNewVehicle: false,
    addNewVehicle: null,   
    loadingvalidateVehicle: false,
    validateVehicle: null,
    loadinguploadDocument: false,
    uploadDocument: null,
  },
  reducers: {
    //reset or delete public store data
    resetAddNewVehicle: (state) => {
      state.addNewVehicle = null;
    },
    resetvalidateVehicle: (state) => {
      state.validateVehicle = null;
    },
    resetuploadDocument: (state) => {
      state.uploadDocument = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionAddNewVehicle.pending, (state) => {
        state.loadingAddNewVehicle = true;
      })
      .addCase(actionAddNewVehicle.fulfilled, (state, action) => {
        state.loadingAddNewVehicle = true;
        state.addNewVehicle = action.payload;
      })
      .addCase(actionAddNewVehicle.rejected, (state) => {
        state.loadingAddNewVehicle = false;
      })
      .addCase(actionValidateVehicle.pending, (state) => {
        state.loadingvalidateVehicle = true;
      })
      .addCase(actionValidateVehicle.fulfilled, (state, action) => {
        state.loadingvalidateVehicle = true;
        state.validateVehicle = action.payload;
      })
      .addCase(actionValidateVehicle.rejected, (state) => {
        state.loadingvalidateVehicle = false;
      })
      .addCase(actionuploadDocument.pending, (state) => {
        state.loadinguploadDocument = true;
      })
      .addCase(actionuploadDocument.fulfilled, (state, action) => {
        state.loadinguploadDocument = true;
        state.uploadDocument = action.payload;
      })
      .addCase(actionuploadDocument.rejected, (state) => {
        state.loadinguploadDocument = false;
      })
  },
});

export const { resetAddNewVehicle, resetvalidateVehicle, resetuploadDocument } = addNewVehicleSlice.actions;

export default addNewVehicleSlice.reducer;
